import {ReducerBuilder} from "@cuatroochenta/co-redux-builders";
import ParkingMeterCollection from "../../../../commons/model/ParkingMeterCollection";
import ParkingMeterCollectionFormCompanyUserScreenActions from "./ParkingMeterCollectionFormCompanyUserScreenActions";
import TaskParkingMeterCollectionDetail from "../../../../commons/ws/parkingMeterCollection/TaskParkingMeterCollectionDetail";

interface InitialState {
    parkingMeterCollectionLoading: boolean,
    parkingMeterCollection?: ParkingMeterCollection,
}

const INITIAL_STATE: InitialState = {
    parkingMeterCollectionLoading: false,
    parkingMeterCollection: undefined,
};

export default ReducerBuilder.newBuilder(INITIAL_STATE)
    .onEvent(TaskParkingMeterCollectionDetail.REDUX_ACTION_OBJECT_ON_PRE_EXECUTE, (oldState) => ({
        ...oldState,
        parkingMeterCollectionLoading: true
    }))
    .onEvent(TaskParkingMeterCollectionDetail.REDUX_ACTION_OBJECT_ON_POST_EXECUTE, (oldState) => ({
        ...oldState,
        parkingMeterCollectionLoading: false
    }))
    .onEvent(TaskParkingMeterCollectionDetail.REDUX_ACTION_OBJECT_ON_SUCCESS, (oldState, payload) => {
        return { ...oldState, parkingMeterCollection: payload.data};
        })

    .onEvent(ParkingMeterCollectionFormCompanyUserScreenActions.clearReducer, () => INITIAL_STATE)

    .build();
